export default __webpack_public_path__ + "static/comp2-7ca834c11ce5bff29d758e2879382ebb.svg";